import Vue from 'vue';

const bus = new Vue();

export default bus;



// WEBPACK FOOTER //
// ./src/js/bus.js